import { ChainItem, ChainList } from './style'
import Block from 'src/components/layout/Block'
import { Field, useField } from 'react-final-form'
import { FIELD_STARTER_TYPE, TypeForm } from './fields/starterFields'
import { useSelector } from 'react-redux'
import { useStepper } from 'src/components/StepperWalliro/stepperContext'
import { useEffect } from 'react'
import { providerNameSelector, shouldSwitchWalletChain } from 'src/logic/wallets/store/selectors'

const options = [
  {
    label: 'Create new Walliro',
    value: TypeForm.open,
  },
  {
    label: 'Load Old Walliro',
    value: TypeForm.load,
  },
]

interface Props {
  callback?: (type: TypeForm) => void
}
const StepThere = ({ callback }: Props) => {
  const providerName = useSelector(providerNameSelector)
  const isWrongNetwork = useSelector(shouldSwitchWalletChain)
  const provider = !!providerName && !isWrongNetwork

  const { setCurrentStep } = useStepper()

  useEffect(() => {
    if (!provider) {
      setCurrentStep(0)
    }
  }, [provider, setCurrentStep])
  return (
    <Block className="px-lg-5 py-lg-4 p-3">
      <ChainList>
        <Field
          name={FIELD_STARTER_TYPE}
          options={options}
          validate={(value) => (value || value === 0 ? undefined : 'Required')}
        >
          {({ input, meta, options }) => {
            return options.map((option, index) => (
              <ChainItem
                key={index}
                size="md"
                className="my-2"
                $isActive={option.value === input.value}
                onClick={() => {
                  callback?.(option.value)
                  input.onChange(option.value)
                }}
              >
                {option.label}
              </ChainItem>
            ))
          }}
        </Field>
      </ChainList>
    </Block>
  )
}

export default StepThere
